import Rest from './../../../plugins/Rest'
import clone from 'lodash.clone'
import i18n from './../../../plugins/i18next'
import validation from './../../../plugins/validation'
import moment from 'moment'
import clearSearch from './../../../plugins/clearSearch'
const state = {
    modal: {
        fields: {
            index: '',
            title: '',
            leasingNumber: '',
            contact: '',
            representative: '',
            leasingItem: '',
            startDate: '',
            endDate: '',
            netWorth: '',
            monthWorth: '',
            instalment: '',
            nettoBuyout: '',
            otherCosts: '',
            description: '',
        },
        errors: {
            stepOne: {
                validation: true,
                fields: {
                    title: '',
                    leasingNumber: '',
                    contact: '',
                    leasingItem: '',
                },
            },
            stepTwo: {
                validation: true,
                fields: {
                    startDate: '',
                    endDate: '',
                    instalment: '',
                    netWorth: '',
                    monthWorth: '',
                    nettoBuyout: '',
                },
            },
        },
        step: 1,
    },
    request: {
        populate: [
            {
                localField: 'currentMenager',
                foreignField: '_id',
                from: 'users',
                as: 'currentMenager',
            },
        ],
        searchFields: ['index', 'contact.name'],
        defaultSearchFields: ['index', 'contact.name'],
        select:
            '_id index leasingNumber status startDate endDate contact monthWorth representative folders leasingStuff isDeleted',
        where: {
            isDeleted: false,
        },
    },
    table: {
        items: [],
        total: '',
        search: '',
        page: 1,
        limit: 11,
        pages: 1,
        defaultSort: '-createdAt',
        loading: false,
    },
    input: {
        items: [],
        search: '',
        limit: 4,
        sort: 'leasingNumber',
        defaultSort: 'leasingNumber',
    },
    dictFields: {
        leasingItem: '',
    },
    statuses: [],
    details: {},
    registry: {},
}

const getters = {
    getLeasingModal: state => state.modal.fields,
    getLeasingError: state => state.modal.errors,
    getLeasingStep: state => state.modal,
    getLeasingTable: state => state.table,
    getLeasingStatuses: state => state.statuses,
    getLeasingsSearchFields: state => state.request,
    getLeasingDetails: state => state.details,
    getLeasingRegistry: state => state.registry,
    getLeasingsInput: state => state.input,
}

const actions = {
    async fetchLeasingTable({ commit }) {
        state.table.loading = true
        try {
            let table = new Rest('GET', 'leasings')
                .select(state.request.select)
                .limit(state.table.limit)
                .page(state.table.page)
                .where(state.request.where)
                .populate(state.request.populate)
                .search(state.request.searchFields, state.table.search)
                .sort(state.table.sort || state.table.defaultSort)
                .send()

            let registryReq = new Rest('GET', 'registries')
                .select('currentMenager name')
                .where({ url: 'leasings' })
                .populate([
                    {
                        path: 'currentMenager',
                        select: 'name lastname mail status phone picture',
                    },
                ])
                .send()
            let { 0: response, 1: registry } = await Promise.all([
                table,
                registryReq,
            ])
            commit('setLeasingTable', response.data)
            commit('setLeasingRegistry', registry.data.items)
        } catch (err) {
            console.error(err)
        }
        state.table.loading = false
    },

    async fetchLeasingRegistry({ commit, dispatch }, payload) {
        let registry = await new Rest('GET', 'registries')
            .select('currentMenager name')
            .where({ url: 'leasings' })
            .populate([
                {
                    path: 'currentMenager',
                    select: 'name lastname mail status phone picture',
                },
            ])
            .send()

        commit('setLeasingRegistry', registry.data.items)
    },

    async createLeasing({ commit, dispatch }, payload) {
        try {
            await new Rest('POST', 'leasings')
                .setBody(state.modal.fields)
                .send()
            commit('clearLeasingModal')
            commit('clearLeasingErrors')
            dispatch('fetchLeasingTable')
            commit('setSnackbars', { type: 'success' })
            return true
        } catch (err) {
            //HANDLE ERRORS
            if (err) {
                commit('setSnackbars', { type: 'error' })
                if (err.response.data.errors.login)
                    commit('setSnackbars', {
                        type: 'error',
                        text: `${i18n.t('leasings:leasingUnique')}!`,
                    })
                validation.setErrors(state.modal.errors, err)
            }
        }
    },

    async fetchLeasing({ state, commit, dispatch }, payload) {
        try {
            let leasing = await new Rest('GET', `leasings/${payload.id}`)
                .populate([
                    {
                        path: 'createdBy',
                        select: 'name lastname mail status phone picture',
                    },
                    {
                        path: 'driver',
                        select: 'name lastname ',
                    },
                    {
                        path: 'leasingStuff.car',
                        select: 'vin isDeleted leasing model typeOfCar',
                    },
                    {
                        path: 'leasingStuff.device',
                        select: 'sn isDeleted model leasing',
                        populate: {
                            path: 'model',
                        },
                    },
                ])
                .select('-folders')
                .send()

            let statusesReq = new Rest('GET', `registries/leasings/statuses`)
                .select('name _id isDeleted color state')
                .where({ isDeleted: false })
                .send()

            let { 0: response, 1: statuses } = await Promise.all([
                leasing,
                statusesReq,
            ])
            dispatch('fetchLeasingRegistry')

            commit('setLeasingDetails', response.data)
            commit('setLeasingStatuses', statuses.data.items)

            if (payload.next) payload.next()
        } catch (err) {
            console.error(err)
        }
    },

    async updateLeasing({ commit, dispatch }, payload) {
        try {
            let response = await new Rest('PUT', `leasings/${payload.id}`)
                .setBody(state.modal.fields)
                .send()
            dispatch('fetchLeasing', { id: payload.id })
            commit('clearLeasingModal')
            commit('clearLeasingErrors')
            return true
        } catch (err) {
            //HANDLE ERRORS
            validation.setErrors(state.modal.errors, err)
            commit('setSnackbars', { type: 'error' })
        }
    },
    async updateLeasingStatus({ commit, dispatch }, payload) {
        commit('setLeasingModal')
        commit('setLeasingStatus', payload.status)
        try {
            let response = await new Rest('PUT', `leasings/${payload.id}`)
                .setBody(state.modal.fields)
                .send()
            commit('setSnackbars', { type: 'success' })
        } catch (err) {
            console.error(err)
            commit('setSnackbars', { type: 'error' })
        }
    },
    async deleteLeasing({ commit, dispatch }, payload) {
        try {
            await new Rest('DELETE', `leasings/${payload.id}`).send()
            dispatch('fetchLeasingTable')
            commit('setSnackbars', { type: 'success' })
            return true
        } catch (err) {
            console.error(err)
        }
    },
    async fetchLeasingsInput({ commit, dispatch }) {
        try {
            let response = await new Rest('GET', 'leasings')
                .select('leasingNumber')
                .limit(state.input.limit)
                .search(state.request.searchFields, state.input.search)
                .where(state.request.where)
                .populate(state.request.populate)
                .sort(state.input.sort || state.input.defaultSort)
                .send()

            commit('setLeasingsInput', response.data)
        } catch (err) {
            console.error(err)
        }
    },
}

const mutations = {
    setLeasingTable(state, payload) {
        state.table.items = payload.items || state.table.items
        state.table.total = payload.total || state.table.total
        if (payload.search != undefined) state.table.search = payload.search
        state.table.page = payload.page || state.table.page
        state.table.limit = payload.limit || state.table.limit
        state.table.pages = Math.ceil(state.table.total / state.table.limit)
        if (payload.sort != undefined) state.table.sort = payload.sort
    },
    setLeasingRegistry(state, payload) {
        state.registry = payload[0]
    },
    setLeasingSearch(state, payload) {
        state.request.searchFields = payload
    },
    setLeasingDetails(state, payload) {
        state.details = payload
    },
    setLeasingStatuses(state, payload) {
        state.statuses = payload
    },
    setLeasingStatus(state, payload) {
        state.modal.fields.status = payload
    },
    setLeasingModal(state, payload) {
        let obj = payload ? payload : clone(state.details)
        state.modal.fields = obj
        state.modal.fields.startDate = obj.startDate
            ? moment(obj.startDate).format('YYYY-MM-DD')
            : ''
        state.modal.fields.endDate = obj.endDate
            ? moment(obj.endDate).format('YYYY-MM-DD')
            : ''
    },
    clearLeasingModal(state, payload) {
        state.modal.step = 1
        state.modal.fields = {
            title: '',
            leasingNumber: '',
            contact: '',
            representative: '',
            leasingItem: '',
            startDate: '',
            endDate: '',
            netWorth: '',
            monthWorth: '',
            instalment: '',
            nettoBuyout: '',
            otherCosts: '',
            description: '',
        }
    },
    clearLeasingErrors(state) {
        for (const step in state.modal.errors) {
            for (const key in state.modal.errors[step].fields) {
                state.modal.errors[step].fields[key] = ''
                state.modal.errors[step].validation = true
            }
        }
    },
    clearLeasingTable(state) {
        clearSearch.clearSearchTable(state)
    },
    setLeasingsInput(state, payload) {
        state.input.items = payload.items || state.input.items
        if (payload.search != undefined) state.input.search = payload.search
        state.input.limit = payload.limit || state.input.limit
        if (payload.sort != undefined) state.input.sort = payload.sort
    },
}

export default {
    state,
    getters,
    actions,
    mutations,
}
